module.exports = function(app) {

    app.factory('registration', ['services', '$q', '$state', '$window', '$filter', "$cookies", "teamsite", "brand", "coremetrics", "sessionData", "brandConfig", "$interval", "session", "appConfig", "storage",
        function(services, $q, $state, $window, $filter, $cookies, teamsite, brand, coremetrics, sessionData, brandConfig, $interval, session, appConfig, storage) {

            var chip14PGVerificationCounter = 0;
            var maxChip14PGVerificationAttempts = 3;

            var handleSuccessResponse = function (response, user, defer) {
                var returnCode = response && response.data && response.data.baseMessage && response.data.baseMessage.returnCode;
                var map = {
                    200: 'REGISTER_INVALID_BRAND',
                    221: 'DUP-REGISTERED',
                    222: 'REGISTER_LOOKS_FAMILIAR',
                    223: 'REGISTER_WRONG_SITE'
                };

                if  (returnCode === 200) {
                    // INVALID BRAND
                    if (response.data && response.data.payload && response.data.payload.brand === "INVALID") {
                        defer.reject( { returnCode: returnCode, returnCodeDescription: map[returnCode] } );
                    } else {
                        defer.resolve({ user: user, response: response.data.payload});
                    }
                } else if (returnCode === 222) {
                    // LOOKS FAMILIAR
                    //TODO: IF we don't implement visitor, this won't be needed.
                    //TODO: IF we do, this will be an alternate step injected into the registration flow (similar to CHIP14)
                    defer.reject( { returnCode: returnCode, returnCodeDescription: map[returnCode] } );

                } else if (returnCode === 224) {
                    // CHIP USER
                    user.isCHIP = true;
                    chip14PGVerificationCounter = 0;
                    defer.resolve({ user: user, response: response.data.payload});

                } else {
                    // For 221, 223, others...
                    defer.reject( { returnCode: returnCode, returnCodeDescription: map[returnCode] } );
                }
            };

            var handleErrorResponse = function (error) {
                var returnCode = (error  && error.data && error.data.baseMessage && error.data.baseMessage.returnCode) || 0;
                var returnCodeDescription = (error && error.data && error.data.baseMessage && error.data.baseMessage.returnCodeDescription) || null;

                if (returnCodeDescription === 'CHIP14_GUARDIAN_VERIFICATION_FAIL') {
                    // Increment the counter for allowable attempts at entering parent or guardian information for chip14 registration.
                    chip14PGVerificationCounter++;
                    if (chip14PGVerificationCounter >= maxChip14PGVerificationAttempts) {
                        returnCodeDescription = 'CHIP14_GUARDIAN_VERIFICATION_EXCEED';
                    }
                }
                return { returnCode: returnCode, returnCodeDescription: returnCodeDescription, chipCounter: chip14PGVerificationCounter };
            };

            var identifyUser = function(user) {
                var defer = $q.defer();

                services.rbsmbl.userIdentification().identify(user).then(
                    function(response) {
                        var returnCode = response && response.data && response.data.baseMessage && response.data.baseMessage.returnCode;
                        var returnCodeDescription = response && response.data && response.data.baseMessage && response.data.baseMessage.returnCodeDescription;
                        user.brand = response.data.payload.brand;

                        if (returnCode === 200) {
                            user.hasProfile = true;
                            response.data.payload.returnCode = returnCode;
                            response.data.payload.returnCodeDescription = returnCodeDescription;
                            defer.resolve( { user: user, response: response.data.payload } );
                        } else {
                            handleSuccessResponse(response, user, defer);
                        }
                    }, function(error) {
                        defer.reject(handleErrorResponse(error));
                    }
                );

                return defer.promise;
            };

            var profile = function(user) {
                var defer = $q.defer();

                services.rbsmbl.consumerProfile().profile(user).then(
                    function(response) {
                        defer.resolve(response);
                    }, function(error) {
                        defer.reject(handleErrorResponse(error));
                    }
                );

                return defer.promise;
            };

            var register = function(user) {
                var defer = $q.defer();

                services.rbsmbl.registerUser().register(user).then(
                    function(response) {
                        defer.resolve(response);
                    }, function(error) {
                        defer.reject(handleErrorResponse(error));
                    }
                );

                return defer.promise;
            };

            var oldRegister = function(user, userType) {
                var defer = $q.defer();

                services.rbsmbl.oldRegister().register(user, userType).then(
                    function(response) {
                        defer.resolve(response);
                    }, function(error) {
                        defer.reject(handleErrorResponse(error));
                    }
                );

                return defer.promise;
            };

            var doLogin = function(user, campaignID, userType) {
                var defer = $q.defer();
                services.rbsmbl.loginversion( { username: user.username } ).fetch().then(function(response) {
                    if (response && response.data && response.data.payload && response.data.payload.loginVersion === 'MER_LOGIN_V1') {

                        var password = response.data.payload.convertCase ? user.password.toUpperCase() : user.password;

                        services.rbsmbl.login().loginWithRedirect(user.username, password, 'loginRedirectCampaign', 'landing').then( function(loginResponse) {

                            if (campaignID && campaignID.length > 0) {
                                $state.go('campaignLogin', { id: campaignID } );
                            } else {
                                if(userType && userType == 'medicareMember'){
                                    $window.location.href = "/#" + $state.params.originalUrl;
                                }else if (brand.current.sharedBrandCode==="mincr"){
                                    $window.location.href = '/member/home';
                                }else{
                                    $window.location.href = '/member/landing';
                                }                               
                            }
                            defer.resolve(loginResponse);

                        }, function(error) {
                            defer.reject(error);
                        });

                    } else {
                        defer.reject('Unsupported login version');
                    }

                }, function(error) {
                    defer.reject(error);
                });
                return defer.promise;
            };

            var loginShop = function(user) {
                var defer = $q.defer();
                
                services
                    .rbsmbl
                    .userLogin()
                    .fetch(user.username, user.verifiedPassword)
                    .then(function(response){
                        var loginData = response.data;
                        brand.override = brand.override || loginData.regions[0].brand;

                        brandConfig.update();

                        defer.resolve(response);
                        services.rbsmbl.userLogin().setDDToken();
                        services.rbsmbl.userLogin().appendToSessionData(loginData);
                    },
                    function(error){
                        defer.reject(error);
                    });

                return defer.promise;
            };

            var notificationFilter = function(type, stateName) {
                return function(item) {
                    var states = item.states && item.states.length > 0 ? item.states.split(',') : [];
                    return item &&
                        item.sections &&
                        item.sections.memberRegistration &&
                        (item.type === type) &&
                        (stateName && stateName.length === 0 ||
                            (states.length === 0 || states.indexOf(stateName) >= 0) );
                };
            };

            var navigationFilter = function(isVisitor) {
                return function(item) {
                    return item && item.sections && (item.sections.memberRegistration || (isVisitor && item.sections.visitorRegistration));
                };
            };

            return {
                identifyUser: identifyUser,
                profile: profile,
                register: register,
                oldRegister: oldRegister,
                loginMember: doLogin,
                loginShop: loginShop,
                notificationFilter: notificationFilter,
                navigationFilter: navigationFilter,
                notifications: {
                    verifyPleaseWait: 'REGISTER_VERIFY_PLEASE_WAIT',
                    registerPleaseWait: 'REGISTER_PLEASE_WAIT',
                    loginPleaseWait: 'REGISTER_LOGIN_PLEASE_WAIT',
                    registerPassLoginFail: 'REGISTER_SUCCESS_LOGIN_FAIL',
                    defaultError: 'REGISTER_DEFAULT_NOTIFICATION'
                }
            };
        }
    ]);
};
